import {Pipe, PipeTransform} from '@angular/core';
import moment, {Moment} from 'moment-timezone';

@Pipe({name: 'minMoment', standalone: false})
export class MinMomentPipe implements PipeTransform {
  transform(value: Moment | null, ...moments: (Moment | null)[]): Moment | null {
    if (moments.length && value?.isValid()) {
      return moment.min([value, ...moments.filter((m): m is Moment => m?.isValid() ?? false)]);
    } else {
      return value;
    }
  }
}
